module.exports = __webpack_public_path__ + "media/images/icons/flags/MW-555d52ecc7eef9989fd0ff5aa0954404.svg";